import { isBlackFridaySaleEnabled, isLunarNewYearEnabled } from "../helpers/outdoor";

const mensCollectionsMenu = data => `
<ul>
    <li class="sectionhead collection" tabindex="1">
        <span data-prefix="men" data-linkid="men:collection">${data.Collection}</span>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="men">${data.Collection}</span>
        </li>
        <li class="s24_veilance CN-block">
            <a href="/c/mens/veilance" data-prefix="men" data-linkid="men:collection:veilance">${data["Veilance Name"]}</a>
        </li>
        <li class="f23_systema">
        <a href="/c/mens/system_a/" data-prefix="men" data-linkid="men:collection:system-a">${data["System_A Name"]}</a>
        </li>
        <li class="professional-use JP-block CN-block">
            <a href="/c/mens/professional-use/" data-prefix="men" data-linkid="men:collection:professional-use">${data["Professional Use"]}</a>
        </li>
    </div>
</ul>
`;

const mensClimbingMenu = data => `
<ul>
    <div>
        <li class="sectionhead s24_climbing_gear" tabindex="1">
            <a href="/c/mens/climbing-gear/" data-prefix="men" data-linkid="men:climbing-gear">${data["Climbing Gear"]}</a>
        </li>
        <div class="mobilefly">
            <li class="mobilehead">
                <span data-prefix="men">${data["Climbing Gear"]}</span>
            </li>
            <li class="s23_climbing_gear_harness">
                <a href="/c/mens/climbing-gear/sub-cat=harnesses" data-prefix="men" data-linkid="men:climbing-gear:harnesses">${data["$^nav-harnesses^$"]}</a>
            </li>
            <li class="s23_climbing_gear_ropebags" style="display:none">
                <a href="/c/mens/climbing-gear/sub-cat=rope-bags" data-prefix="men" data-linkid="men:climbing-gear:rope-bags">${data["$^nav-ropeBags^$"]}</a>
            </li>
            <li class="s23_climbing_gear_chalkbags">
                <a href="/c/mens/climbing-gear/sub-cat=chalk-bags" data-prefix="men" data-linkid="men:climbing-gear:chalk-bags">${data["$^nav-chalkBags^$"]}</a>
            </li>
        </div>
    </div>
</ul>
`;

const mensFootwearMenu = data => `
<ul>
    <li class="sectionhead w23_ftw" tabindex="1">
        <a href="/c/mens/footwear/" data-prefix="men" data-linkid="men:footwear">${data.Footwear}</a>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="men">${data.Footwear}</span>
        </li>
        <li class="s23_ftw_boots">
            <a href="/c/mens/footwear/sub-cat=boots" data-prefix="men" data-linkid="men:footwear:boots">${data["$^nav-boots^$"]}</a>
        </li>
        <li class="s23_ftw_shoes">
            <a href="/c/mens/footwear/sub-cat=shoes" data-prefix="men" data-linkid="men:footwear:shoes">${data["$^nav-shoes^$"]}</a>
        </li>
    </div>
    <li class="spacer">
        <span>&nbsp;</span>
    </li>
</ul>
`;

const mensClothingMenu = data => `
<ul>
        <li class="sectionhead f23_clothing" tabindex="1">
        <a href="/c/mens" data-linkid="men:clothing" data-prefix="men">${data.Clothing}</a>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="men">${data.Clothing}</span>
        </li>
        <li class="s23-shelljacket_windshell_m_nav">
            <a href="/c/mens/shell-jackets/" data-prefix="men" data-linkid="men:clothing:shell-jackets">${data["Shell Jackets"]}</a>
        </li>
        <li class="s24_insulatedjacket">
            <a href="/c/mens/insulated-jackets/" data-prefix="men" data-linkid="men:clothing:insulated-jackets">${data["Insulated Jackets"]}</a>
        </li>
        <li class="s24_pants">
            <a href="/c/mens/pants/" data-prefix="men" data-linkid="men:clothing:pants">${data.Pants}</a>
        </li>
        <li class="s24_fleece">
            <a href="/c/mens/fleece/" data-prefix="men" data-linkid="men:clothing:fleece">${data.Fleece}</a>
        </li>
        <li class="f23_baselayer JP-block">
            <a href="/c/mens/base-layer/" data-prefix="men" data-linkid="men:clothing:base-layer">${data["Base Layer"]}</a>
        </li>
        <li class="s24_shirtstops">
            <a href="/c/mens/shirts-and-tops/" data-prefix="men" data-linkid="men:clothing:shirts-and-tops">${data["Shirts & Tops"]}</a>
        </li>
        <li class="s24_shorts">
            <a href="/c/mens/shorts/" data-prefix="men" data-linkid="men:clothing:shorts">${data.Shorts}</a>
        </li>
    </div>
</ul>
`;

const mensPacksMenu = data => `
<ul>
    <li class="sectionhead s24_packs" tabindex="1">
        <a href="/c/mens/packs/" data-prefix="men" data-linkid="men:packs">${data.Packs}</a>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="men">${data.Packs}</span>
        </li>
        <li class="s23_packs_daypack">
            <a href="/c/mens/packs/sub-cat=daypacks" data-prefix="men" data-linkid="men:packs:daypacks">${data["$^nav-daypacks^$"]}</a>
        </li>
        <li class="s23_packs_multiday">
            <a href="/c/mens/packs/sub-cat=multi-day" data-prefix="men" data-linkid="men:packs:multi-day">${data["$^nav-multiDay^$"]}</a>
        </li>
        <li class="s23_packs_travelcommute">
            <a href="/c/mens/packs/sub-cat=travel-and-commute" data-prefix="men" data-linkid="men:packs:travel-and-commute">${data["$^nav-travelAndCommute^$"]}</a>
        </li>
    </div>
</ul>
`;

const mensAccessoriesMenu = data => `
<ul>
    <li class="sectionhead s24_accessories" tabindex="1">
        <a href="/c/mens/accessories/" data-prefix="men" data-linkid="men:accessories">${data.Accessories}</a>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="men">${data.Accessories}</span>
        </li>
        <li class="s23_accessories_gloves">
            <a href="/c/mens/accessories/sub-cat=gloves" data-prefix="men" data-linkid="men:accessories:gloves">${data["$^nav-gloves^$"]}</a>
        </li>
        <li class="f23_accessories_toquesbeanies">
            <a href="/c/mens/accessories/sub-cat=toques-and-beanies" data-prefix="men" data-linkid="men:accessories:toques-and-beanies">${data["$^nav-toquesAndBeanies^$"]}</a>
        </li>
        <li class="s24_accessories_hatscaps">
            <a href="/c/mens/accessories/sub-cat=hats-and-caps" data-prefix="men" data-linkid="men:accessories:hats-and-caps">${data["$^nav-hatsAndCaps^$"]}</a>
        </li>
        <li class="f23_socks">
            <a href="/c/accessories?sub-cat=socks&gender=mens" data-prefix="men" data-linkid="men:accessories:socks">${data.Socks}</a>
        </li>
        <li class="s23_accessories_productcare ">
            <a href="/c/mens/accessories/sub-cat=product-care" data-prefix="men" data-linkid="men:accessories:product-care">${data["$^ProductCare^$"]}</a>
        </li>
        <li class="s23_accessories_more">
            <a href="/c/mens/accessories/sub-cat=more" data-prefix="men" data-linkid="men:accessories:more">${data["$^nav-more^$"]}</a>
        </li>
    </div>
</ul>
`;

const mensIntendedUseMenu = data => `
<ul class="intendeduse">
    <li class="sectionhead intended-use" tabindex="1">
        <span data-prefix="men">${data["$^nav-IntendedUse^$"]}</span>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="men">${data["$^nav-IntendedUse^$"]}</span>
        </li>
        <li class="s24_alpinerockclimb">
            <a href="/c/mens/alpine-and-rock-climbing" data-prefix="men" data-linkid="men:intended-use:alpine-and-rock-climbing">${data["Alpine & Rock Climbing"]}</a>
        </li>
        <li class="s24_hiketrekk">
            <a href="/c/mens/hiking-and-trekking" data-prefix="men" data-linkid="men:intended-use:hiking-and-trekking">${data["$^nav-hikingAndTrekking^$"]}</a>
        </li>
        <li class="f23_skisnowboard JP-block">
            <a href="/c/mens/skiing-and-snowboarding" data-prefix="men" data-linkid="men:intended-use:skiing-and-snowboarding">${data["$^nav-skiAndSnowboard^$"]}</a>
        </li>
        <li class="s24_trailrun">
            <a href="/c/mens/trail-running" data-prefix="men" data-linkid="men:intended-use:trail-running">${data["$^nav-trail-running^$"]}</a>
        </li>
        <li class="f23_everyday">
            <a href="/c/mens/everyday" data-prefix="men" data-linkid="men:intended-use:lifestyle">${data.Everyday}</a>
        </li>
    </div>
</ul>
`;

export const mensShopMoreMenu = (data, country) => `<ul class="shopmore">
        <li class="sectionhead shop-more" tabindex="1">
            <span data-prefix="men">${data["$^nav-ShopMore^$"]}</span>
        </li>
        <div class="mobilefly">
            <li class="mobilehead">
                <span data-prefix="men" data-linkid="men:shop-more">${data["$^nav-ShopMore^$"]}</span>
            </li>
            ${
              isBlackFridaySaleEnabled(country)
                ? `<li class="f23_blackfridaysale black-friday">
                <a href="/c/mens/p/black-friday-sale" data-prefix="men" data-linkid="sale:black-friday-sale-mens">${data["Black Friday Sale"]}</a>
            </li>`
                : ""
            }
            <li class="s24_newarrivals">
                <a href="/c/mens/new-arrivals" data-prefix="men" data-linkid="men:shop-more:new-arrivals">${
                  data["New Arrivals"]
                }</a>
            </li>
            <li class="s24_beta_family">
                <a href="/c/mens/beta-family/wid-6j8yr8q9" data-prefix="men" data-linkid="men:shop-more:beta-family">${
                  data["Beta Family"]
                }</a>
            </li>
            <li class="s24_athlete_picks">
                <a href="/c/mens/athlete-picks/wid-rj01vqzl" data-prefix="men" data-linkid="men:shop-more:athlete-picks">${
                  data["Athlete Picks"]
                }</a>
            </li>
            <li class="ski-and-snowboard-gear-guide">
                <a href="/shop/ski-and-snowboard-product-guide" data-prefix="men" data-linkid="men:shop-more:ski-and-snowboard-collection">${
                  data["Ski & Snowboard Collection"]
                }</a>
            </li>
            <li class="s24_gifts_for_him">
                <a href="/c/mens/p/gifts-for-him" data-prefix="men" data-linkid="men:shop-more:gifts-for-him">${
                  data["Gifts for Him"]
                }</a>
            </li>
            <li class="f23_shellfinder">
                <a href="/shop/jacket-finder/mens" data-prefix="men" data-linkid="men:shop-more:shell-finder">${
                  data["$^nav-shellFinder^$"]
                }</a>
            </li>
            <li class="footwear-finder">
                <a href="/shop/footwear-finder" data-prefix="men" data-linkid="men:shop-more:footwear-finder">
                    ${data["$^nav-footwearFinder^$"]}
                </a>
            </li>
            <li class="layering-guide">
                <a href="/shop/mens-layering-guide" data-prefix="men" data-linkid="men:shop-more:layering-guide">${
                  data["$^nav-layering-guide^$"]
                }</a>
            </li>
            <li class="arctype">
                <a href="/c/mens/p/favourites" data-prefix="men" data-linkid="men:shop-more:favourites">${
                  data.Favourites
                }</a>
            </li>
            <li class="s23_exclusives JP-block">
                <a href="/c/mens/exclusives" data-prefix="men" data-linkid="men:shop-more:exclusives">${
                  data.Exclusives
                }</a>
            </li>
            <li class="s24_travel-collection">
                <a href="/shop/mens-travel-collection" data-prefix="men" data-linkid="men:shop-more::travel-collection">${
                  data["$^nav-travelCollection^$"]
                }</a>
            </li>
            <li class="whats-your-warmest">
                <a href="/c/mens/p/whats-your-warmest" data-prefix="men" data-linkid="men:shop-more::whats-your-warmest">${
                  data["What's Your Warmest"]
                }</a>
            </li>
            ${
              isLunarNewYearEnabled()
                ? `<li class="lunar-new-year">
                <a href="/shop/lunar-new-year" data-prefix="men" data-linkid="men:shop-more::lunar-new-year">${data["Year of the Dragon Capsule"]}</a>
            </li>`
                : ""
            }
        </div>
    </ul>`;

const mensShoppingCategoryMenusFdp = (data, country) => `
    ${mensClothingMenu(data)}

    <div class="group">
        ${mensPacksMenu(data)}
        ${mensFootwearMenu(data)}
    </div>
    <div class="group">
        ${mensAccessoriesMenu(data)}
        ${mensClimbingMenu(data)}
    </div>
    <div class="nav-item__divider"></div>
    ${mensIntendedUseMenu(data)}
    <div class="nav-item__divider"></div>
    ${mensCollectionsMenu(data)}
    <div class="nav-item__divider"></div>
    ${mensShopMoreMenu(data, country)}
`;

export const mensShoppingCategoryMenu = (data, country) => mensShoppingCategoryMenusFdp(data, country);
